// A collection rail stays subordinate to the app's records. The compact
// rules use available pane space, including a narrow pane on a wide screen.
//
// THE RAIL IS ITS CARD, on the one sidebar glass (Nika 2026-10-30: "Glass
// like all sidebars (Recommended)"): the shared AppSidebarCard (AppSidebar.js
// — the brand `navbar` glass, the `float` lift, the CommonCard corner), listed
// first so the AppSidebar column recipe wins where the two overlap. This
// reverses the opaque `cardSolid` rail of the app-frame pass (abe8f88cd) on
// purpose: every sidebar paints one surface. Its padding is set here again;
// the type size stays the column's (no fontSize on the card).
export const AppCollectionSidebar = {
  extends: ['AppSidebarCard', 'AppSidebar'],
  width: 'G',
  minWidth: '0',
  maxWidth: '100%',
  height: 'fit-content',
  maxHeight: 'calc(100% - 2 * var(--spacing-A))',
  alignSelf: 'flex-start',
  margin: 'A 0 A A',
  padding: 'A',
  gap: 'Z',
  overflow: 'auto',
  overscrollBehavior: 'contain',
  Top: null,
  PeopleSection: null,
  ViewSwitcher: null,
  Middle: { display: 'contents' },
  '@mobileL': {
    width: 'auto',
    alignSelf: 'stretch',
    margin: 'A A 0',
    padding: 'A',
    maxHeight: '30dvh'
  },
  '@appMobile': {
    width: 'auto',
    alignSelf: 'stretch',
    margin: 'A A 0',
    padding: 'A',
    maxHeight: '30%'
  }
}
